import Locales from '../../../assets/const/locales';

export default {
    [Locales.ENGLISH]: {
        filters: 'Filters',
        productsTitle: 'Products',
        rateplansTitle: 'Rateplans',
        articlesTitle: 'Articles',
        supportTitle: 'Support',
        perPage12: '12 per page',
        perPage24: '24 per page',
        perPage48: '48 per page',
        mostRelevant: 'Relevant',
        alphabeticalAsc: 'Alphabetical - Ascending',
        alphabeticalDesc: 'Alphabetical - Descending',
        priceAsc: 'Price - Ascending',
        priceDesc: 'Price - Descending'
    },
    [Locales.GREEK]: {
        filters: 'Φίλτρα',
        productsTitle: 'Προϊόντα',
        rateplansTitle: 'Προγράμματα',
        articlesTitle: 'Άρθρα',
        supportTitle: 'Υποστήριξη',
        perPage12: '12 ανά σελίδα',
        perPage24: '24 ανά σελίδα',
        perPage48: '48 ανά σελίδα',
        mostRelevant: 'Συνάφεια',
        alphabeticalAsc: 'Αλφαβητικά - Αύξουσα',
        alphabeticalDesc: 'Αλφαβητικά - Φθίνουσα',
        priceAsc: 'Τιμή - Αύξουσα',
        priceDesc: 'Τιμή - Φθίνουσα'


    },
};